export default {
  firebaseConfig: {
    apiKey: 'AIzaSyDXwa7Bzui5ljz3yh_EIkPavF1Op5XbYYY',
    authDomain: 'site-lite.firebaseapp.com',
    databaseURL: 'https://site-lite.firebaseio.com',
    projectId: 'site-lite',
    storageBucket: 'site-lite.appspot.com',
    messagingSenderId: '158063168259',
    appId: '1:158063168259:web:6d42b426cd08c9b078f736',
    measurementId: 'G-2L8FVPKF5Y'
  }
}
